import React, { useState, useEffect } from 'react';
import { TouchableOpacity, View } from 'react-native';
import ReactDatePicker from 'react-datepicker';
import { format } from 'date-fns-tz';
import { DNAIcon, TextField, util } from "../../../index";
import colors from '../../../theming/themes/alucio/colors';
import 'react-datepicker/dist/react-datepicker.css';
const DatePicker = (props) => {
    const { minDate, maxDate, onDismiss, placeholder, onDateSelected, onShowCalendar, selectedDate, showMonthYearDropDown = false, disabled, includeTimePicker = false, showTimeSelectOnly = false, showTimeSelect = false, dateFormat, timeIntervals = 30, customFormat, minTime, maxTime, ...TextInputKittenProps } = props;
    const [currSelectedDate, setCurrSelectedDate] = useState(selectedDate);
    function handleChange(date) {
        if (!minTime || (date && date >= minTime)) {
            setCurrSelectedDate(date);
        }
        if (onDateSelected) {
            onDateSelected(date);
        }
    }
    useEffect(() => { setCurrSelectedDate(selectedDate); }, [selectedDate]);
    const CustomInput = React.forwardRef(({ onChange, placeholder, value, onClick }, ref) => {
        const clickHandler = (e) => {
            onShowCalendar?.(e);
            onClick?.(e);
        };
        const calIcon = (props) => (<DNAIcon.Styled {...props} disabled={disabled} status="subtle" name="calendar-dots"/>);
        const customFormatedValue = customFormat && selectedDate
            ? format(new Date(selectedDate), customFormat)
            : undefined;
        return (<TouchableOpacity onPress={clickHandler} activeOpacity={1}>
          <View pointerEvents="none">
            <TextField.Kitten size={'lg'} // Not sure why TS is throwing a fit here
         textStyle={util.mergeStyles(undefined, {}, [{ color: colors['color-black'] }, !disabled])} multiline={false} maxLength={10} disabled={disabled} style={{ backgroundColor: colors['color-text-white'] }} placeholder={placeholder} value={customFormatedValue ?? value} accessoryRight={calIcon} onChange={onChange} ref={ref} {...TextInputKittenProps}/>
          </View>
        </TouchableOpacity>);
    });
    return (<ReactDatePicker selected={currSelectedDate} onChange={handleChange} minDate={minDate} maxDate={maxDate} showYearDropdown={showMonthYearDropDown} showMonthDropdown={showMonthYearDropDown} showTimeInput={showTimeSelectOnly ? false : includeTimePicker} showTimeSelect={showTimeSelectOnly || showTimeSelect} onCalendarClose={onDismiss} disabled={disabled} showTimeSelectOnly={showTimeSelectOnly} timeIntervals={timeIntervals} dateFormat={dateFormat} minTime={minTime} maxTime={maxTime} popperPlacement="top-start" portalId="root-portal" popperModifiers={{
            flip: {
                behavior: ['top', 'bottom'],
            },
            preventOverflow: {
                enabled: false, // tell it not to try to stay within the view (this prevents the popper from covering the element you clicked)
            },
            hide: {
                enabled: false, // turn off since needs preventOverflow to be enabled
            },
        }} customInput={<CustomInput />}/>);
};
DatePicker.displayName = 'DatePicker';
export default DatePicker;
//# sourceMappingURL=DatePicker.web.js.map